/**
 * @file defaultRange.ts
 * @brief Shared default 30-day AnalyticsRange for company reports.
 *
 * @author DES
 * @date 27-07-2026
 */

import type { AnalyticsRange as RangeBarValue } from "@/features/analytics/components/AnalyticsRangeBar";

export function defaultReportRange(): RangeBarValue {
  const end = new Date();
  const start = new Date();
  start.setDate(end.getDate() - 30);
  start.setHours(0, 0, 0, 0);
  end.setHours(23, 59, 59, 999);
  return {
    startDate: start.toISOString(),
    endDate: end.toISOString(),
    groupBy: "day",
  };
}
